module.exports = __webpack_public_path__ + "img/pitching2.71989ff3.png";